module.exports = __webpack_public_path__ + "static/media/Bok-min.26b1df36.PNG";